import axios from "utils/axios";
import { generateBaseUri } from "utils/helper";

export const singleLogin = (email, password, remember, is_otp) => {
  const data = {
    email,
    password,
    remember_me: remember,
    is_otp,
    use_jwt: 1, // Backend JWT flow: response ikut berisi refresh_token
  };

  return axios.post("/WA/authentication", data, {
    headers: { Authorization: false },
  });
};

// JWT: kirim refresh_token supaya sesi di-revoke di BE
export const logout = ({ token, refreshToken } = {}) => {
  return axios.post(
    "/authentication/logout",
    refreshToken ? { refresh_token: refreshToken } : {},
    {
      baseURL: generateBaseUri({ ignoreInitEndpoint: true }),
      headers: { Authorization: `Bearer ${token}` },
      // Token lokal sudah dihapus saat logout → jangan refresh / tampilkan "Login expired"
      _skipAuthRefresh: true,
      skipErrorNotification: true,
    },
  );
};

export const turnOfflineLogout = (apiToken, config = {}) => {
  return axios.post(
    "/WA/onlines",
    { is_online: 0 },
    { ...config, headers: { Authorization: `Bearer ${apiToken}` } },
  );
};

export const getInits = (params, config = {}) => {
  return axios.get("/WA/inits", { params, ...config });
};

export const getVerificationToken = () => {
  return axios.get("/WA/verificationToken");
};

export const changeLanguage = (lang) => {
  return axios.patch("/authentication/user/lang", { lang });
};

export const updateProfile = (data) => {
  return axios.put("/authentication/user", data);
};

export const changePassword = (data) => {
  return axios.put("/authentication/password", data);
};

export const revokeLogin = () => {
  return axios.post("/authentication/revoke");
};

export const requestRecovery = (data) => {
  return axios.post("/authentication/password/recovery", data, {
    headers: { Authorization: false },
  });
};
export const verifyToken = (token) => {
  return axios.get(`/authentication/password/recovery/${token}`, {
    headers: { Authorization: false },
  });
};

export const reset = (data) => {
  return axios.post(`/authentication/password/recovery/reset`, data, {
    headers: { Authorization: false },
  });
};

export const getUsers = () => {
  return axios.get("/users");
};

export const addUser = (data) => {
  return axios.post("/users", data);
};

export const updateUser = (data, id) => {
  return axios.put(`/users/${id}`, data);
};

export const deleteUser = (id) => {
  return axios.delete(`/users/${id}`);
};

export const resendInvitation = ({ id }) => {
  return axios.post(`/users/resendInvitation/${id}`);
};

export const verifyGoogleToken = (access_token) => {
  return axios.post(
    "/google-auth/verify",
    { access_token },
    { headers: { Authorization: false } },
  );
};

export const getUserRegisterByToken = ({ token }) => {
  return axios.get(`/users/register/${token}`);
};

export const inviteUserWithRegister = (data) => {
  return axios.post("/users/register", data, {
    headers: { Authorization: false },
  });
};

export const acceptInvitation = (data) => {
  return axios.post("/users/acceptInvitation", data, {
    headers: { Authorization: false },
  });
};

export const generateOtp = (data) => {
  return axios.post("/authentication/generateOtp", data, {
    headers: { Authorization: false },
  });
};

export const getPhoneProfile = (params) => {
  return axios.get("/users/phoneProfile", { params });
};

export const getInhouseProfile = (params) => {
  return axios.get("/users/inhouseProfile", { params });
};
